import { Component, OnDestroy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'btn-cell-renderer-prev-task-form',
    template: `
    <style>
        .edit-btn {
            color: white;
            background: #3aafe4;
            margin-right: 5px;
        }
        .view-btn {
            color: white;
            background: #17a2b8;
            margin-right: 5px;
        }
        .delete-btn {
            color: white;
            background: red;
            margin-right: 5px;
        }
        i {
            color: white;
            padding-bottom: 15px
        }
        .btn:disabled {
            opacity: 0.5;
            cursor: not-allowed;
        }
        .btn {
            padding: 7px 10px;
            border: none;
            border-radius: 5px;
            cursor: pointer;
        }
        .d-flex {
            display: flex;
        }
    </style>
    <div class="d-flex">
        <button class="delete-btn btn custom-tooltip" *ngIf="isDelete && !isStatusCompletedOrClosed" title="Delete" mat-icon-button tooltipPosition="top" (click)="onClickDelete($event)">
            <i class="fa fa-trash" aria-hidden="true"></i>
        </button>

        <button class="view-btn btn custom-tooltip" *ngIf="isUpdate && isStatusCompletedOrClosed" title="View" mat-icon-button tooltipPosition="top" (click)="onClickView($event)">
            <i class="fa fa-eye" aria-hidden="true"></i>
        </button>

        <button class="edit-btn btn custom-tooltip" *ngIf="isUpdate && !isStatusCompletedOrClosed" title="Edit" mat-icon-button tooltipPosition="top" (click)="onClickEdit($event)">
            <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
        </button>
    </div>
    `
})

export class ActionEditDeleteBtnRendererPrevTaskForm implements ICellRendererAngularComp, OnDestroy {
    params: any;
    isUpdate: boolean = false;
    isDelete: boolean = false;
    isStatusCompletedOrClosed = false;

    // If you want to implement the refresh method
    refresh(params: any): boolean {
        this.params = params;
        this.checkStatus();
        return true;
    }

    agInit(params: any): void {
        this.params = params;
        this.isUpdate = params.isUpdate ?? false;
        this.isDelete = params.isDelete ?? false;
        this.checkStatus();
    }

    checkStatus(): void {
        const status = this.params?.data?.status?.toLowerCase();
        this.isStatusCompletedOrClosed = status === 'completed' || status === 'closed' || status === 'complete' || status === 'close';
    }

    onClickView($event: any): void {
        if (this.params.onClickView instanceof Function) {
            const params = {
                event: $event,
                rowData: this.params.node.data,
                index: this.params.node.rowIndex
            };
            this.params.onClickView(params);
        }
    }

    onClickEdit($event: any): void {
        if (this.params.onClickEdit instanceof Function) {
            const params = {
                event: $event,
                rowData: this.params.node.data,
                index: this.params.node.rowIndex
            };
            this.params.onClickEdit(params);
        }
    }

    onClickDelete($event: any): void {
        if (this.params.onClickDelete instanceof Function) {
            const params = {
                event: $event,
                rowData: this.params.node.data,
                index: this.params.node.rowIndex
            };
            this.params.onClickDelete(params);
        }
    }

    ngOnDestroy(): void {
        // Cleanup if necessary (optional)
    }
}
